import * as ActionTypes from '../../actions/ActionTypes';
import ReportsFilterRecord from '../../records/insights/ReportsFilterRecord';
import { getThisMonthTimeRange } from '../../utils/reportUtils';
export default function reportsFilterInfo(
// @ts-expect-error ts-migrate(2322) FIXME: Type '{ startDate: DateObject; endDate: DateObject... Remove this comment to see the full error message
state = new ReportsFilterRecord({
  dateRange: getThisMonthTimeRange()
}), action) {
  switch (action.type) {
    case ActionTypes.UPDATE_REPORT_DATE_FILTER:
      return state.set('dateRange', action.payload);
    default:
      return state;
  }
}